module.exports = __webpack_public_path__ + "static/cosygiraffepink-b6ac00529956e9cea883f5ed44a4e3f0.jpeg";